import {
  EHeadingStyleVariant,
  ELinkColorVariant,
  ELinkVariant,
  EModalSize,
  EModalVariants,
  Heading,
  Link,
  Modal,
} from '@outdoorsyco/bonfire';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { useBreakpoint } from '@/hooks/useBreakpoint';
import { IAmenityList } from '@/utility/mapAmenities';

import { AmenitiesModalContent } from '../../listing/Amenities/Amenities';

interface IListingAmenitiesProps {
  amenities: IAmenityList;
  colorVariant?: ELinkColorVariant;
  isRVBundle?: boolean;
}

export const ListingAmenities = ({
  amenities,
  colorVariant = ELinkColorVariant.Primary,
  isRVBundle = false,
}: IListingAmenitiesProps) => {
  const intl = useIntl();

  const { isMobile } = useBreakpoint();
  const { categories, list } = amenities;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  if (!list.length) {
    return null;
  }

  return (
    <>
      <Link
        label={
          isRVBundle
            ? intl.formatMessage({ defaultMessage: 'View RV amenities', id: '3R6HU5' })
            : intl.formatMessage({ defaultMessage: 'View Amenities', id: '3cKJO5' })
        }
        onClick={() => setModalIsOpen(true)}
        onClickCapture={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        variant={ELinkVariant.Underline}
        colorVariant={colorVariant}
      />

      <Modal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        size={EModalSize.Medium}
        variant={isMobile ? EModalVariants.Bottom : undefined}>
        <Modal.Actions />
        <Modal.Header className="mb-4">
          <Heading variant={EHeadingStyleVariant.H5}>
            {isRVBundle
              ? intl.formatMessage({ defaultMessage: 'RV Amenities', id: '912lLb' })
              : intl.formatMessage({ defaultMessage: 'Amenities', id: 'e38GOF' })}
          </Heading>
        </Modal.Header>
        <Modal.Content>
          <AmenitiesModalContent categories={categories} items={list} />
        </Modal.Content>
      </Modal>
    </>
  );
};
